export default __webpack_public_path__ + "static/media/5a474a6e7b1f479bd3460647342da0091602463968437.1fbefda2.webp";